// Simplified horizontal fade scroll component
function horizontalFadeScroll() {
  return {
    init() {
      const container = this.$refs.slider;
      if (!container) return;

      const updateFade = () => {
        const scrollLeft = container.scrollLeft;
        const maxScroll = container.scrollWidth - container.clientWidth;
        const threshold = 10;

        // Set data attributes for CSS to use
        container.dataset.fadeLeft = scrollLeft <= threshold ? "0" : "1";
        container.dataset.fadeRight = scrollLeft >= maxScroll - threshold ? "0" : "1";
      };

      container.addEventListener("scroll", updateFade, { passive: true });
      updateFade();
    }
  };
}

export default horizontalFadeScroll;
